const copyDetails = [
    {
        name: "githublink",
        content: "https://github.com/lyznne/Konsole-night_Theme.git"
    },
    {
        name: "themelink",
        content: "ext install Enoslyznne.konsole-night"
    },
];

export default copyDetails;